// DELEGATE — the per-user Evidence usage read and its transport moved to
// `@heidi/evidence`; the app-resolved auth gate is what stays.
//
// The pre-move hook gated its `queryFn` on `token && enabled` and issued the
// request inline through `@/utils/scribeHTTP`. The transport moved onto the
// `@heidi/api/client` registry (`data/api/userActivity.ts`) and the two-term
// gate collapses to the one boolean the package takes. Bodied rather than a
// re-export because that collapse is real work: `enabled` alone would issue the
// request before auth resolves.
//
// `EvidenceUsageStatsResponse` is DECLARED in `@heidi/evidence/contracts` and
// re-exported here name-intact — `useQueryTeamEvidenceUsageStats` and the
// trial-recap surface both import it from this path today.
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import { useQueryEvidenceUsageStats as useQueryEvidenceUsageStatsCore } from '@heidi/evidence/data';

export { EVIDENCE_USAGE_STATS_QUERY_KEY } from '@heidi/evidence/contracts';
export type { EvidenceUsageStatsResponse } from '@heidi/evidence/contracts';

/**
 * GET /api/v2/ml-scribe/user-activity/evidence
 *
 * Per-user evidence usage stats for surfaces such as the 90-day trial recap modal.
 */
export function useQueryEvidenceUsageStats(enabled: boolean) {
  const { isAuthenticated } = useIsAuthenticated();

  return useQueryEvidenceUsageStatsCore(isAuthenticated && enabled);
}
